import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { FlexBox } from '../box';
import { Menu } from '../menu';
import { Tooltip } from '../tooltip';
import { LanguagePickerMenuItem } from './menu-item';
import { LanguagePickerSelectedMenuItem } from './menu-selected-item';
import { StyledMenuButton } from './styled';
export const LanguagePickerMenu = observer((props) => {
    const { options, selectedOption, disabled, disabledTooltipText, onChange } = props;
    const [isOpen, setIsOpen] = React.useState(false);
    const buttonContent = (_jsx(StyledMenuButton, { "$isDisabled": disabled, "$isOpen": isOpen, children: selectedOption && (_jsx(LanguagePickerSelectedMenuItem, { option: selectedOption, localeOptionsCount: options.length, isDisabled: disabled })) }));
    return (_jsx(FlexBox, { hAlign: "center", children: _jsx(Tooltip, { title: disabled ? disabledTooltipText : undefined, disabled: !disabled || !disabledTooltipText, children: disabled ? (buttonContent) : (_jsx(FlexBox, { children: _jsx(Menu, { actions: options.map((option) => ({
                        primary: (_jsx(LanguagePickerMenuItem, { option: option })),
                        onClick: () => onChange(option.value)
                    })), onOpen: () => setIsOpen(true), onClose: () => setIsOpen(false), children: buttonContent }) })) }) }));
});
